import React, { useCallback, useState } from 'react';
import { AnimatePresence } from 'framer-motion';
import { Maximize2Icon } from 'lucide-react';
import { BeforeAfterSlider } from './BeforeAfterSlider';
import { GalleryLightbox } from './GalleryLightbox';
import { useLanguage } from '../../hooks/useLanguage';
import { galleryProjects, GalleryProject } from '../../data/gallery';
import { ui } from '../../data/translations';
export function Gallery() {
  const {
    t
  } = useLanguage();
  const [active, setActive] = useState<GalleryProject | null>(null);
  const close = useCallback(() => setActive(null), []);
  return <section id="gallery" className="w-full bg-white py-20 lg:py-28" data-id="element-106" data-mp="1nb7z553kzyrc">
      <div className="mx-auto max-w-7xl px-5 lg:px-8" data-id="element-107" data-mp="1s9j9ri1padam">
        <div className="max-w-2xl" data-id="element-108" data-mp="1sa1el32fhzu5">
          <h2 className="font-display text-3xl font-bold leading-tight text-navy lg:text-4xl" data-id="element-109" data-mp="1sbceuswo0pgi">{t(ui.gallery.title)}</h2>
          <p className="mt-4 text-steel" data-id="element-110" data-mp="3mnaj0gg4av5j">{t(ui.gallery.subtitle)}</p>
        </div>

        <ul className="mt-12 grid gap-8 sm:grid-cols-2 lg:grid-cols-3" data-id="element-111" data-mp="37xa7nhew8gh6">
          {galleryProjects.map(project => <li key={project.id} className="overflow-hidden rounded-lg border border-black/10 bg-white shadow-sm" data-id="element-112" data-mp="32yp7tj3jzyt9">
              <BeforeAfterSlider before={project.before} after={project.after} alt={t(project.title)} beforeLabel={t(ui.gallery.before)} afterLabel={t(ui.gallery.after)} dragLabel={`${t(ui.gallery.drag)}: ${t(project.title)}`} data-id="element-113" data-mp="3hm1td7td24jn" />
              <div className="flex items-start justify-between gap-3 p-5" data-id="element-114" data-mp="2k1fm1vara98u">
                <div data-id="element-115" data-mp="2xzvubqo9o7t3">
                  <h3 className="font-display text-base font-semibold text-navy" data-id="element-116" data-mp="2xwzrbnxkasxs">{t(project.title)}</h3>
                  <p className="mt-1 text-sm text-steel" data-id="element-117" data-mp="2tzlivyhpgp6u">{t(project.description)}</p>
                </div>
                <button type="button" onClick={() => setActive(project)} aria-label={`${t(ui.gallery.expand)}: ${t(project.title)}`} className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md border border-black/10 text-navy transition-colors duration-150 hover:border-navy hover:bg-mist" data-id="element-118" data-mp="dapy6wl1fefh">
                  <Maximize2Icon className="h-4 w-4" aria-hidden="true" data-id="element-119" data-mp="3by3hvs9jdqq0" />
                </button>
              </div>
            </li>)}
        </ul>
      </div>

      <AnimatePresence data-id="element-120" data-mp="2jctvguy8ssf5">{active && <GalleryLightbox project={active} onClose={close} data-id="element-121" data-mp="2j963i08g4e2j" />}</AnimatePresence>
    </section>;
}